export const API_VERSION = 'v2.14.2';
export const SOCKET_PREFIX = '/signalr-hubs/etransfer';
